@if (option.emoji) {
  <div class="icon">{{ option.emoji }}</div>
}
@if (option.remixIcon) {
  <i [class]="option.remixIcon" class="remix-icon"></i>
}
@if (option.imageFilePath) {
  <div
    class="image w-100"
  [ngStyle]="{
    'background-image': 'url(' + option.imageFilePath + ')',
    'background-size': option.imageMode === 'cover' ? 'cover' : 'contain',
    'background-position': option.imageMode === 'cover' ? 'top' : 'center',
    height: option.imageMode === 'cover' ? '160px' : '120px',
  }"
  ></div>
}
@if (option.rive) {
  <canvas
    #animation
    class="w-100"
    width="480"
    [height]="480 / option.rive.ratio"
    [ngStyle]="{
      transform:
        'translateY(' + (option.rive.shiftDown ?? '0') + ') ' + (option.rive.flip ? 'scaleX(-1)' : 'scaleX(1)'),
    }"
    >
  </canvas>
}
@if (option.title) {
  <div
    class="title"
    [ngClass]="{ 'tile-title': option.rive || option.imageFilePath }"
    >
    {{ option.title }}
    @if (option.isNextIconShown) {
      <i class="ri-arrow-right-line"></i>
    }
  </div>
}
